import React, { Component } from 'react';


export default class ProductInfo2 extends Component {

    render() {
        const { product } = this.props;
        return (
            <React.Fragment>
                <div style={{ display: 'flex' }}>
                    <div style={{ textAlign: 'center', border: '1px solid #c6c6c6', marginRight: '5px', width: '30%' }}>
                        <img src={product.productInfoResponse.imageUrls[0].thumbnail} style={{ maxWidth: '100%', maxHeight: '100px' }} alt="product" />
                    </div>
                    <div style={{ width: '70%' }}>
                        <div className="v-imp-txt top-ten">{product.productInfoResponse.title}</div>
                        <div className="top-ten" style={{ display: 'flex', justifyContent: 'space-evenly', flexWrap: 'wrap' }}>
                            <div className="pr-mrp2">MRP {product.mrp}</div>
                            {(product.manufacturerOffer) ?
                                <div style={{ padding: '8px', backgroundColor: 'rgb(95 169 70 / 30%)', borderRadius: '8px', margin: '5px' }}>
                                    {/* <img src={offerIcon} alt="offer" />  */}
                                    {product.manufacturerOffer.title}
                                </div> : null
                            }
                        </div>
                    </div>
                </div>
                <div style={{ borderBottom: '2px solid #dfdfdf', marginTop: '5px' }}></div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <div>Quantity Received: </div>
                        <div>{product.receivedQuantity} Unit(s)</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <div>Status: </div>
                        {(product.receivedQuantity < product.purchaseOrderQuantity) ?
                            <div style={{ color: '#BD2E23', marginLeft: '15px' }}>Short Inward</div>
                            :
                            <div style={{ color: '#58a159', marginLeft: '15px' }}>All units received as per PO</div>
                        }
                    </div>
                </div>
            </React.Fragment>


        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Commons/ProductInfo2.js